const BYTES_PER_MEGABYTE = 1024 * 1024;

// Keep the patient-registration field limit aligned with the backend default.
export const PATIENT_REGISTRATION_FILE_MAX_SIZE_MB = 5;
export const PATIENT_REGISTRATION_PHOTO_MAX_SIZE_MB = 2;

// The request cap is below the Nginx 32 MB cap to leave room for multipart and
// patient JSON overhead while still allowing the supported patient documents.
export const PATIENT_REGISTRATION_REQUEST_MAX_SIZE_MB = 25;
export const PATIENT_REGISTRATION_REQUEST_MAX_SIZE_BYTES =
  PATIENT_REGISTRATION_REQUEST_MAX_SIZE_MB * BYTES_PER_MEGABYTE;

type PendingFile = {
  size: number;
};

export interface PatientRegistrationUploadValues {
  patient_photo_pending?: PendingFile | null;
  government_identifier_document_pending?: PendingFile | null;
  abha_id_document_pending?: PendingFile | null;
  insurance_records?:
    | readonly {
        insurance_card_letter_pending?: PendingFile | null;
      }[]
    | null;
}

export const getPatientRegistrationPendingFileSizeBytes = (
  values: PatientRegistrationUploadValues,
) => {
  const pendingFiles = [
    values.patient_photo_pending,
    values.government_identifier_document_pending,
    values.abha_id_document_pending,
    ...(values.insurance_records ?? []).map(
      (record) => record.insurance_card_letter_pending,
    ),
  ];

  return pendingFiles.reduce((total, file) => total + (file?.size ?? 0), 0);
};

export const isPatientRegistrationRequestWithinSizeLimit = (
  values: PatientRegistrationUploadValues,
) =>
  getPatientRegistrationPendingFileSizeBytes(values) <=
  PATIENT_REGISTRATION_REQUEST_MAX_SIZE_BYTES;
